import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface DiscountCampaign {
  id: string;
  name: string;
  plan_codes: string[] | null;
  discount_percentage: number;
  discount_months: number;
  campaign_start: string;
  campaign_end: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

/** Returns the single currently active campaign (for public use on PricingPage) */
export function useActiveCampaign() {
  const [campaign, setCampaign] = useState<DiscountCampaign | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const now = new Date().toISOString();
      const { data } = await supabase
        .from('discount_campaigns')
        .select('*')
        .eq('is_active', true)
        .lte('campaign_start', now)
        .gt('campaign_end', now)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      setCampaign(data ?? null);
      setLoading(false);
    })();
  }, []);

  return { campaign, loading };
}

/** Returns all campaigns (for admin use) */
export function useAllCampaigns() {
  const [campaigns, setCampaigns] = useState<DiscountCampaign[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCampaigns = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('discount_campaigns')
      .select('*')
      .order('created_at', { ascending: false });

    setCampaigns(data ?? []);
    setLoading(false);
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  return { campaigns, loading, refetch: fetchCampaigns };
}
